import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const choiceInvoiceSchema = Yup.object().shape({
  choiceInvoice: Yup.string().required(globalMessages.form.required),
});

export default choiceInvoiceSchema;
